import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { withApp } from "../lib/story";
import { navItemAllowed } from "../lib/master";

export default function GovernanceCue({ guide, appId }) {
  if (!guide?.pointer) return null;
  const to = withApp(guide.detail_route || "/", appId);
  const canOpen = navItemAllowed(guide.detail_route || "/", guide);
  return (
    <aside className="governance-cue" data-testid="governance-cue">
      <div>
        <p className="kicker">GOVERNANCE POINTER · {guide.role}</p>
        <strong>{guide.pointer}</strong>
        {guide.detail && <p className="muted small-note">{guide.detail}</p>}
        {guide.accountable_owner && (
          <p className="muted small-note" data-testid="governance-owner">Accountable: {guide.accountable_owner}</p>
        )}
      </div>
      {canOpen ? (
        <Link data-testid="governance-see-details" className="secondary-button small-btn" to={to}>
          See details <ChevronRight size={14} />
        </Link>
      ) : (
        <span data-testid="governance-request-review" className="muted small-note">
          Request a detailed review
        </span>
      )}
    </aside>
  );
}
